import { render, staticRenderFns } from "./Divide.vue?vue&type=template&id=99d385e0&scoped=true"
import script from "./Divide.vue?vue&type=script&lang=js"
export * from "./Divide.vue?vue&type=script&lang=js"
import style0 from "./Divide.vue?vue&type=style&index=0&id=99d385e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d385e0",
  null
  
)

export default component.exports